import axios from 'axios';
import config from '../../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../../core/modules/common/tools/URLTools';

const apiFetchPredesImpcCodeUsageNonComplianceDetails = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getPredesImpcCodeUsageNonComplianceDetails',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchPredesImpcCodeUsageNonComplianceDetails;
